import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';

export default component$(
  ({ cssClasses }: { cssClasses?: string }): JSX.Element => {
    return (
      <svg
        width='22'
        height='22'
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        class={cssClasses}
      >
        <path d='M19.5 13a1 1 0 100-2 1 1 0 000 2zM12.5 13a1 1 0 100-2 1 1 0 000 2zM5.5 13a1 1 0 100-2 1 1 0 000 2z' />
      </svg>
    );
  }
);
